<template>
  <!-- record -->
  <div class="receipt" style="font-family: '微软雅黑';">
    <div class="page" v-for="(item, index) in record.patientInfusionList" :id='scriptInfo(index)'
      :key="item.prescription + 'info'">
      <!-- 处方信息 -->
      <div style="font-size: 8pt; line-height: 16pt;font-family: '微软雅黑';">
        <p style="float: left;">NO.{{ record.inquiryInfo.recordId }}</p>
        <div style="float: right;">
          <p style="display: inline-block;float: right;">
            <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
          </p>
          <p
            style="width: 25pt;float: right; text-align:center;height: 14pt;line-height: 14pt;border:1pt solid rgba(51,51,51,1);border-radius:3pt;display: inline-block;margin-right: 8pt;">
            普通</p>
        </div>
      </div>
      <div style="clear: both;"></div>
      <h3 style="text-align: center; font-size: 16pt;margin-top: 0pt;font-family: '微软雅黑';font-weight: normal;">
        {{ printConfig.titleName || $store.state.global.countInfo.hospitalName }}</h3>
      <h4 style="text-align: center; font-size: 14pt;margin-top: -12pt;font-family: '微软雅黑';font-weight: normal;">输液处方笺&nbsp;({{ index + 1}})
      </h4>
      <div class="user-info" style="margin-top: -10pt;font-size: 9pt;font-family: '微软雅黑';">
        <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            姓名：{{ record.patient.patientName }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            性别：{{ record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            年龄：
            <span v-if="record.inquiryInfo.clinicalAge">{{ record.inquiryInfo.clinicalAge }}</span>
            <span v-else>
              <span v-if="record.patient.year > 0">{{ record.patient.year }}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{
                record.patient.month }}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{ record.patient.day }}天</span>
            </span>
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;; line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            手机号：{{ record.patient.phoneNo }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            科室：{{ record.inquiryInfo.laboratoryName }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            就诊日期：{{ record.inquiryInfo.clinicalTime }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div>
            临床诊断：{{ record.inquiryInfo.diagnosisResultString }}
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div>
            过敏史：{{ record.inquiryInfo.allergyHistory }}
          </div>
        </div>
      </div>
      <!-- 字母 -->
      <div style="line-height: 12pt;">
        <h1 style="font-size: 17pt;display: inline-block;font-family:DFPSongW7;float:left;">R</h1>
        <h2 style="font-size: 12pt;display: inline-block;font-family:DFPSongW7;float:left;">p</h2>
      </div>
      <div style="clear: both;"></div>
    </div>
    <!-- 处方 -->
    <div class="page" v-for="(item, index) in record.patientInfusionList" :id='idAdd(index)' :key="item.prescription">
      <!-- 输液处方 -->
      <div class="group" style="font-size:9pt;line-height:1.8;margin-top:8pt;font-family: '微软雅黑';"
        v-for="(it, idx) in item.patientInfusionGroupList" :key="item.id + idx">
        <div>组{{ idx + 1 }}：</div>
        <div class="drug" v-for="(i) in it.patientDrugList" :key="i.drugId" style="line-height:1.6">
          <span style="width: 40%;display: inline-block;">{{ i.drugName }}</span>
          <span style="width: 30%;display: inline-block;">{{ i.specification }}</span>
          <span style="width: 10%;display: inline-block;">{{ i.totalDosage }} {{ i.totalDosageUnit }}</span>
          <span style="width: 20%;display: inline-block;text-align: right;">{{ i.dosage }}{{ i.dosageUnit }}/次</span>
        </div>
        <div style="line-height:1.2">
          <span style="display: inline-block;">用法：{{ it.usage }}</span>
          <span style="margin-left: 10pt;display: inline-block;">{{ it.useRate }}</span>
          <span style="margin-left: 10pt;display: inline-block;">x{{ it.dayCount }}天</span>
        </div>
      </div>
    </div>
    <!-- 诊所信息 -->
    <div style="margin-top: 0px;font-size: 9pt;font-family: '微软雅黑';" id="footer-info-infusion">
      <div style="font-size: 9pt;border-bottom: 1pt solid #999;; line-height: 24pt;height:24pt;font-family: '微软雅黑';">
        <div style="float: left; width: 49.99%;">
          医生：<span>{{ record.realName }}</span>
        </div>
        <div style="float: right; width: 49%;text-align: center;">
          <!--{{ prescriptionAmt }}-->
          金额：<span v-show="printConfig.printTotalPrice == 1">￥<span id="infusionTotalSum0"></span></span>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div
        style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt;width: 100%;font-family: '微软雅黑';">
        <div style="float: left; width: 24.3%;">
          审查：
        </div>
        <div style="float: left; width: 24.3%;">
          调配：
        </div>
        <div style="float: left; width: 24.3%;">
          核对：
        </div>
        <div style="float: left; width: 24.3%;">
          发药：
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="font-size: 9pt;line-height: 24pt;font-family: '微软雅黑';">
        注：{{ printConfig.remark }}
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { BigNumber } from 'bignumber.js';
import {printTemplateA5} from "./print";

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  /** 
   *  type 的几种类型
   *  medicine -> 成药
   *  pieces -> 饮片
   *  infusion -> 输液
   *  apply -> 服帖
   *  infusionCard -> 输液卡
   *  other -> 其他
  */
  props: {
    record: {
      type: Object,
      default: {
        patientInfusionList: [],
      },
    },
    isReview: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      printTime: '',
      cur_type: 'infusion',
    }
  },
  methods: {
    print ({ isReview } = {}) {
      this.newPrint()
      // if (!this.record.patientInfusionList) return;
      // const infusionList = this.record.patientInfusionList.map((item) => {
      //   const groupList = item.patientInfusionGroupList.map((it) => {
      //     const drugList = {
      //       ...it,
      //     }
      //     drugList.startTime = drugList.startTime.slice(0, 10);
      //     return drugList;
      //   })
      //   return groupList;
      // });
      // this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      // const { scriptValue } = this.$store.state.global.printConfig;
      // this.$nextTick(() => {
      //   const LODOP = getLodop();
      //   LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
      //   LODOP.PRINT_INIT('输液处方打印');//打印初始化
      //   LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '输液处方打印');//设置纸张大小
      //   infusionList.forEach((item, index) => {
      //     LODOP.ADD_PRINT_HTM(0, '5%', '90%', '50mm', document.getElementById(`${this.cur_type}-info` + index).innerHTML);
      //     LODOP.SET_PRINT_STYLEA(0, "ItemType", 4);
      //     LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //     LODOP.ADD_PRINT_HTM('75mm', '5%', '90%', '110mm', document.getElementById(this.cur_type + index).innerHTML);
      //
      //     document.getElementById('infusionTotalSum0').innerText = this.priceIndex(index)
      //     LODOP.ADD_PRINT_HTM('160mm', '5%', '90%', '50mm', document.getElementById('footer-info-infusion').innerHTML);
      //     // LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      //     // LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
      //     LODOP.SET_PRINT_STYLEA(0, "ItemType", 4);
      //     LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
      //     LODOP.NewPageA();
      //   });
      //   LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
      //   LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
      //   LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
      //   LODOP.SET_PRINTER_INDEX(scriptValue);
      //   // if (isReview) {
      //   //   LODOP.PREVIEW();
      //   // } else {
      //   //   LODOP.PRINT();
      //   // }
      //   LODOP.PREVIEW();
      // });
    },
    // 打印输液处方  新
    newPrint() {
      // console.log(this.record, 'this.record')
      // patientChineseDrugList

      const LODOP = getLodop();
      let title = {
        company: this.printConfig.titleName || this.$store.state.global.countInfo.hospitalName,
        type: '输液处方笺',
        ...this.record.inquiryInfo,
        ...this.record.patient,
        ...this.printConfig,
        realName: this.record.realName,
        sex: this.record.patient.gender == -1 ? '未知' : (this.record.patient.gender == 0 ? '女' : '男'),
      }
      let oldList = JSON.parse(JSON.stringify(this.record.patientInfusionList))
      let chineseNum = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']

      let chunkList = []

      for (let j = 0; j < oldList.length; j++) {
        let printList = oldList[j].patientInfusionGroupList
        let obj = {amount: this.priceIndex(j), printTypeTitle: `输液处方笺(${chineseNum[j]})`}

        let list = printList.reduce((prev, item, index) => {
          prev.push({printIndex: `组${index + 1}`,  printType: 'group', ...obj})

          for (let i = 0; i < item.patientDrugList.length; i++) {
            let v = item.patientDrugList[i]
            v.printIndex = i + 1
            // v.printTypeTitle = `输液处方笺(${chineseNum[j]})`
            prev.push({...item, ...v, ...obj})
          }

          prev.push({...item, printType: 'useFn', ...obj})

          if (printList.length == index + 1) {
          } else  {
            prev.push({printType: 'nullRow'})
          }

          return prev
        }, [])

        let splitArrNum = 17

        for (let i = 0; i < list.length; i += splitArrNum) {
          const chunk = list.slice(i, i + splitArrNum);
          chunkList.push(chunk);
        }
      }

      console.log(chunkList)

      for (let i = 0; i < chunkList.length; i++) {
        printTemplateA5(title, chunkList[i], LODOP)
        LODOP.NewPage()
      }

      LODOP.PREVIEW()
    },
    // 计算金额
    drugAmt (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取打印配置
    getPrintConfig () {
      this.$api.clinicManagement.getPrintConfit({ configType: 6 }).then((res) => {
        this.printConfig = res;
      })
    },
    scriptInfo (index) {
      return `${this.cur_type}-info` + index;
    },
    idAdd (index) {
      return this.cur_type + index;
    },
    // 获取单个输液组价格总和
    getGroupTotalAmt (list) {
      const sub = list.patientDrugList.reduce((a, b) => {
        const salePrice = Number(b.univalence);
        const dosage = Number(b.totalDosage);
        return BN(a).plus(Number(this.drugAmtSub(salePrice, dosage))).toFixed(2);
      }, 0);
      return sub;
    },
    // 药品单项合计金额-返回0
    drugAmtSub (price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return 0;
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取单个输液处方价格总和
    getInfusionListAmt (list) {
      return this.getGroupTotalAmt(list);
      // const sub = this.getGroupTotalAmt(list);
      // const frequency = this.getFrequency(list.useRate);
      // return BN(sub).multipliedBy(frequency).multipliedBy(list.dayCount).toFixed(2);
      // return BN(sub).toFixed(2);
    },
    // 获取用药频率每日对应次数
    getFrequency (frequencyVal, index, indexs) {
      let num = 1;
      if (frequencyVal !== '') {
        // 过滤频次数据
        let matchStr = '';
        let start = frequencyVal.indexOf('(');
        const end = frequencyVal.indexOf(')');
        if (start > 0) {
          start += 1;
        }
        matchStr = frequencyVal.substring(start, end);
        // qd---1日1次，bid---1日2次，tid---1日3次，qid---1日4次
        switch (matchStr) {
          case 'qd':
            num = 1;
            break;
          case 'bid':
            num = 2;
            break;
          case 'tid':
            num = 3;
            break;
          case 'qid':
            num = 4;
            break;
          default:
            num = 1;
            break;
        }
      }
      return num;
    },
    priceIndex(index) {
      if (!this.record.patientInfusionList || this.record.patientInfusionList.length === 0) return 0;
      let sum = 0
      let patientInfusion = this.record.patientInfusionList[index]
      let patientInfusionGroup = patientInfusion.patientInfusionGroupList.reduce((c, d) => {
        return c + Number(this.getInfusionListAmt(d));
      }, 0);
      sum = (patientInfusionGroup).toFixed(2)
      console.log('sum',sum)
      return sum
    }
  },
  computed: {
    laboratoryName () {
      return this.$store.state.global.countInfo.laboratoryName;
    },
    // 计算处方价格
    prescriptionAmt () {
      if (!this.record.patientInfusionList || this.record.patientInfusionList.length === 0) return '';
      const subPatientInfusionList = this.record.patientInfusionList.reduce((a, b) => {
        const sub = b.patientInfusionGroupList.reduce((c, d) => {
          return c + Number(this.getInfusionListAmt(d));
        }, 0);
        return a + Number(sub);
      }, 0); // 输液处方费用总和
      return BN(subPatientInfusionList).toFixed(2);
    },
  },
  mounted () {
    this.getPrintConfig();
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2px solid #000000;
}

.receipx {
  width: 300px;
  justify-content: space-between;
}

span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1pt solid #000000;
  z-index: 100;
  width: 1000px;
  background: white;
  left: -5000px;
  top: 100px;
}
</style>
